/**
 * PURPOSE: "Inscritos sin serie": inscritos de la categoría que no están en ninguna serie (admin).
 * RESPONSIBILITIES: Listarlos y ofrecer "Agregar a esta serie" para la serie abierta. Se oculta en
 *   pruebas oficiales o sin permiso de escritura (lo decide el detalle).
 * COLLABORATORS: PruebaDetailPanel.jsx.
 * ROUTE: winscore/src/area/AtletismoResultadosArea/components/UnassignedPanel.jsx
 */
import React from "react";
import { FiPlus, FiUserPlus } from "react-icons/fi";

import { institutionAbrev } from "../labels.js";
import { Spinner } from "./ui.jsx";

export const unassignedKey = (item) =>
  item?.teamId != null ? `team-${item.teamId}` : `entry-${item?.entryId}`;

const UnassignedPanel = ({ unassigned, roundLabel, disabled, busyKey, onAdd }) => {
  const list = Array.isArray(unassigned) ? unassigned : [];
  if (!list.length) return null;
  return (
    <div className="border-t border-slate-100 bg-slate-50/60 px-4 py-3">
      <p className="mb-2 flex items-center gap-1.5 text-xs font-black uppercase tracking-wide text-slate-500">
        <FiUserPlus aria-hidden="true" /> Inscritos sin serie ({list.length})
      </p>
      <ul className="grid grid-cols-1 gap-1.5 md:grid-cols-2">
        {list.map((item) => {
          const key = unassignedKey(item);
          return (
            <li
              key={key}
              className="flex items-center justify-between gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5"
            >
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-slate-800">{item.name || "Sin nombre"}</p>
                <p className="text-[11px] font-bold text-slate-500" title={item.institution?.name}>
                  {institutionAbrev(item.institution)}
                </p>
              </div>
              <button
                type="button"
                onClick={() => onAdd(item)}
                disabled={disabled}
                className="inline-flex shrink-0 items-center gap-1 rounded-lg bg-indigo-50 px-2 py-1 text-[11px] font-bold text-indigo-700 transition hover:bg-indigo-100 disabled:cursor-not-allowed disabled:opacity-50"
                title={`Agregar a ${roundLabel || "esta serie"}`}
              >
                {busyKey === key ? <Spinner className="h-3 w-3" /> : <FiPlus aria-hidden="true" />}
                Agregar a esta serie
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default UnassignedPanel;
